export const paypalClientId =  'AXUeits4FjokCII_bm3D8IgfsUrPW3d3xeY5L_lU132Ywqb640ZJLFX1lA-NLhBGt5N2T5ULqsmRsVGT';
export const paypalUrl =  'https://api.sandbox.paypal.com';
// export const apiUrl = "https://run.prystavka.com/api/";
export const apiUrl = "https://reg.sunpiology.com/api/";